import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Auth } from '@aws-amplify/auth';
import { environment } from '@env/fe';
import { AuthService } from '@twaice-fe/frontend/shared/services';
import { SvgIconModule } from '@twaice-fe/frontend/shared/ui-components';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { FeatureToggleModule } from 'ngx-feature-toggle';
import { AccountOverviewComponent } from './account-overview/account-overview.component';
import { InternalUiConfigComponent } from './internal-ui-config/internal-ui-config.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { TimezoneComponent } from './timezone/timezone.component';

@Component({
  selector: 'twaice-fe-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  imports: [
    CommonModule,
    NzMenuModule,
    NzLayoutModule,
    SvgIconModule,
    AccountOverviewComponent,
    InternalUiConfigComponent,
    PasswordChangeComponent,
    TimezoneComponent,
    FeatureToggleModule,
  ],
})
export class SettingsComponent implements OnInit {
  activeItem = 0;
  release = environment.release?.slice(0, 12);
  isSSOUser = false;

  constructor(protected authService: AuthService) {}

  ngOnInit() {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        this.isSSOUser = !!user?.signInUserSession?.idToken?.payload?.identities;
      })
      .catch(() => {
        this.isSSOUser = false;
      });
  }

  showItem(itemNumber: number) {
    this.activeItem = itemNumber;
  }
}
